import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import iopexLogo from "../assets/images/iopex.webp";
import mobileFrame from "../assets/images/frame.webp";
import Banneri from "../assets/images/Banner.png";
import ApplePass from "../assets/images/ApplePass.png";
import GooglePass from "../assets/images/GooglePass.png";
import Interstitiali from "../assets/images/Interstitial.png";
import Nativei from "../assets/images/Native.png";
import VideoAd from "../assets/images/Video.png";
import Websitei from "../assets/images/OnSite.png";
import bg from "../assets/images/bg.png";
import BSafety from "../assets/images/Safety.png";
import Notifications from "../assets/images/notifications.png";
import Videom from "../assets/images/Video.mp4";
import Yieldd from "../assets/images/Yield.png";

function AdTouchpoints() {
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState("In App");
  const [selectedOption, setSelectedOption] = useState("");

  // Normalize option keys
  const normalizeKey = (key) => key.replaceAll(" ", "_");

  // Preview links
  const previewLinks = {
    Banner: Banneri,
    Interstitial: Interstitiali,
    Native: Nativei,
    Video: Videom,
    Rich_Media: Videom,

    Websites: Websitei,
    API_integrations: Websitei,
    Loyalty_and_rewards_platforms: ApplePass,
    Email_and_push_notifications: Notifications,
    POS_systems: Websitei,
    Digital_wallets: ApplePass,
    Marketing_Services: Yieldd,

    Audience_identification: Interstitiali,
    Ad_placement: Interstitiali,
    Offer_redemption: Interstitiali,
    Omni_channel_attribution: Interstitiali,
    Campaign_measurement: Interstitiali,
    Food_and_Beverage: "https://p-11-7-rptormcd-ca-j.pages.dev/",
    Banking: "https://testcit2h.pages.dev/",
    Automobile: "https://testvlksgnkinro.pages.dev/",
    Retail: "https://wmsubsmash.pages.dev/",
    Media_and_entertainment: "https://testpanda-nh7.pages.dev/",
    Consumer_Goods: "https://testrxnacpaamrsoc.pages.dev/",
    Pharmaceuticals: "https://kenvuem.pages.dev/",

    Google: GooglePass,
    iOS: ApplePass,
    Trust_Brand_Safety: Yieldd,
  };

  // Categories
  const cardData = {
    "In App": {
      title: "Ads",
      items: ["Banner", "Interstitial", "Native", "Video", "Rich Media"],
    },
    "On-Site": {
      title: "Channels",
      items: [
        "Websites",
        "API integrations",
        "Loyalty and rewards platforms",
        "Email and push notifications",
        "POS systems",
        "Digital wallets",
        "Marketing Services",
      ],
    },
    "Off-Site": {
      title: "CX Journey",
      items: [
        "Audience identification",
        "Ad placement",
        "Offer redemption",
        "Omni channel attribution",
        "Campaign measurement",
      ],
    },
    "Playable Ads": {
      title: "Industries",
      items: [
        "Food and Beverage",
        "Banking",
        "Automobile",
        "Media and entertainment",
        "Consumer Goods"
      ],
    },
    "Add to Wallet": {
      title: "Platform",
      items: ["Google", "iOS"],
    },
    "Trust & Brand Safety": {
      title: "Platform",
      items: [],
    },
  };

  const { title, items } = cardData[activeButton];

  // Auto select first radio or Trust fallback
  useEffect(() => {
    if (activeButton === "Trust & Brand Safety") {
      setSelectedOption("Trust_Brand_Safety");
    } else if (items && items.length > 0) {
      setSelectedOption(items[0]);
    } else {
      setSelectedOption("");
    }
  }, [activeButton]);

  // Current preview
  const currentPreview =
    activeButton === "Trust & Brand Safety"
      ? BSafety
      : previewLinks[normalizeKey(selectedOption)];

  return (
    <div className="ad-touchpoints-container">
      {/* Header */}
      <header className="whyus-header">
        <img src={iopexLogo} alt="iOPEX Logo" className="whyus-logo" />
      </header>

      <h1 className="how-title">Integrated Service Capabilities</h1>

      {/* Tabs */}
      <div className="how-tab-container">
        <div className="how-tab-wrapper">
        <button className="how-tab active">Ad Touchpoints</button>

          <button className="how-tab" onClick={() => navigate("/how-we-do")}>
            Orchestration Layer
          </button>
          
        </div>
      </div>

      {/* 3-column layout */}
      <div className="ad-touchpoints-content">
        {/* LEFT PANEL (kept for layout, hidden visually when Trust is active) */}
        <div
          className={`options ${
            activeButton === "Trust & Brand Safety" ? "invisible-panel" : ""
          }`}
        >
          {items.length > 0 && (
            <>
              <div className="options-header">{title}</div>
              <div className="options-body">
                {items.map((item) => (
                  <label key={item} className="radio-label">
                    <input
                      type="radio"
                      name="adOption"
                      value={item}
                      checked={selectedOption === item}
                      onChange={() => setSelectedOption(item)}
                    />
                    {item}
                  </label>
                ))}
              </div>
            </>
          )}
        </div>

        {/* CENTER - Mobile Frame */}
       {/* CENTER - Mobile Frame */}
<div className="mobile-frame-wrapper">
  <img src={mobileFrame} alt="Frame" className="mobile-frame" />
  <div className="mobile-content">
    {activeButton === "Trust & Brand Safety" ? (
      <img
        src={BSafety} // 🔹 FIXED: show Safety.png instead of bg
        alt="Trust & Brand Safety"
        className="mobile-preview"
        style={{
          width: "100%",
          height: "100%",
          // objectFit: "cover",
          borderRadius: "20px",
        }}
      />
    ) : currentPreview ? (
      currentPreview.endsWith(".mp4") ? (
        <video
          key={currentPreview}
          src={currentPreview}
          className="mobile-preview"
          autoPlay
          muted
          loop
          playsInline
          controls
          style={{
            width: "100%",
            height: "100%",
            // objectFit: "cover",
          }}
        />
      ) : currentPreview.endsWith(".png") ||
        currentPreview.endsWith(".png") ||
        currentPreview.endsWith(".webp") ? (
        <img
          src={currentPreview}
          alt={selectedOption}
          className="mobile-preview"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <iframe
          src={currentPreview}
          title={selectedOption}
          className="mobile-preview"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            objectFit: "cover",
          }}
        />
      )
    ) : (
      <div className="placeholder-text">Select an option to preview</div>
    )}
  </div>
</div>


        {/* RIGHT PANEL - Category Buttons & Next Button */}
        <div className="categories">
          {Object.keys(cardData).map((key) => (
            <React.Fragment key={key}>
              <button
                className={`category-button ${
                  activeButton === key ? "active" : ""
                }`}
                onClick={() => {
                  setActiveButton(key);
                  const first = cardData[key].items[0];
                  setSelectedOption(
                    first || (key === "Trust & Brand Safety" ? "Trust_Brand_Safety" : "")
                  );
                }}
              >
                {key}
              </button>

              {/* “Next...” appears separately below Trust button */}
              {key === "Trust & Brand Safety" &&
                activeButton === "Trust & Brand Safety" && (
                  <button
                    className="next-inline-btn"
                    
                    onClick={() => navigate("/help")}
                  >
                    Next...
                  </button>
                )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdTouchpoints;
